import React, { MouseEvent } from 'react';
import _ from 'lodash';
import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';
import { useSelector } from 'react-redux';
import { projectColors as selectProjectColors } from 'spw-redux/modules/projects/selectors';
import { getColor } from 'spw-shared/utils';
import styled from 'styled-components';
import { colors } from 'spw-theme';
import { selectShowWorksheetUpdateDialog } from 'spw-redux/modules/calculators/selectors';
import {
  ActionIcon,
  ColorDot,
  UnusedSpaceTypesListTriggerWrapper,
  WorksheetHeaderIcon,
} from './styles';

const Subtitle = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export function ManageSpaceTypes({
  projectSpaceTypeCategory,
  disabled,
  isTotalProgramScenario,
  isDownload = false,
  onManageSpaceTypesButtonClick,
}: {
  projectSpaceTypeCategory: IProjectSpaceTypeCategory;
  disabled: boolean;
  isTotalProgramScenario: boolean;
  isDownload?: boolean;
  onManageSpaceTypesButtonClick: (
    event: React.MouseEvent<HTMLDivElement>,
    spaceTypeCategoryId: number
  ) => void;
}) {
  const projectColors = useSelector(selectProjectColors);
  const isShowingWorksheetUpdateDialog = useSelector(
    selectShowWorksheetUpdateDialog
  );
  const title = projectSpaceTypeCategory.name;
  const testingSuffix = title.replace(' ', '_');
  const disableTrigger =
    isTotalProgramScenario || disabled || isShowingWorksheetUpdateDialog;
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onManageSpaceTypesButtonClick(event, projectSpaceTypeCategory.id);
  };

  return (
    <>
      <UnusedSpaceTypesListTriggerWrapper
        onClick={
          !disableTrigger
            ? (event: React.MouseEvent<HTMLDivElement>) => {
                handleClick(event);
              }
            : undefined
        }
        data-cy={`${projectSpaceTypeCategory.defaultSpaceTypeCategory.category}_manage_space_types`}
        $disablePointer={disableTrigger}
      >
        <ActionIcon>
          <ColorDot
            color={getColor(
              projectSpaceTypeCategory.defaultSpaceTypeCategory.category,
              projectColors
            )}
            className="large-button color-dot"
          >
            <WorksheetHeaderIcon
              src={`/images/${projectSpaceTypeCategory.icon}.svg`}
              alt={`${projectSpaceTypeCategory.name}-icon`}
            />
          </ColorDot>
        </ActionIcon>

        <div className="texts">
          <div
            className="title"
            data-testid={`worksheet_category_row_title_${testingSuffix}`}
            style={isDownload ? { fontSize: '13px' } : undefined}
          >
            {_.toUpper(title)}
          </div>
          {!isDownload && !isTotalProgramScenario && (
            <Subtitle
              style={{
                color: `${disableTrigger ? colors.mainGray : colors.mainBlue}`,
              }}
            >
              Manage Space Types
            </Subtitle>
          )}
        </div>
      </UnusedSpaceTypesListTriggerWrapper>
    </>
  );
}
